/**
 * The IVA rate the quote screens **display** — `W4-T16` Q2. Display only, and provisional.
 *
 * ADR-017 §3.1: a quote's `amountCents` is entered and stored **before IVA**, and the screens compute
 * and show the IVA and the total. They need *a* rate to do that, and which rate applies (21% general,
 * 10% for some home repairs, none for a provider in a special regime) is an accountant's question,
 * `W5-T09` `[H]`. Until it is answered, this is the general rate, in one place.
 *
 * **It is not the rate anything is charged at.** The contract's `withIva` takes a rate as an argument
 * and has no default, so the charge (`W5-T02`) carries its own rate per payment and must never import
 * this one — which it cannot, from the API, and which ADR-013 §4.1's amendment says in words.
 */
export const DISPLAY_IVA_RATE = 0.21;
